export const listType = state => {
  let temps = state.listType
  let lists = []

  if (Array.isArray(temps) && temps.length) {
    temps.forEach(temp => {
      lists.push({
        id: temp.id,
        label: temp.name,
        code: temp.code
      })
    })
  }

  return lists
}

export const listStatus = state => {
  let temps = state.listStatus
  let lists = []

  if (Array.isArray(temps) && temps.length) {
    temps.forEach(temp => {
      lists.push({
        id: temp.id,
        label: temp.name,
        description: temp.description
      })
    })
  }

  return lists
}
